import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Table from 'react-bootstrap/Table';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { SpinnerDotted } from 'spinners-react';
import envValues from '../../enviornment';
import { getCookies } from '../../hooks/useCookies';

function repTrackerComponent() {
  const { userId } = useParams();
  const token = `Bearer ${getCookies('Token')}`;

  const [filter, setFilter] = useState('weekly');
  const [repTrackerData, setRepTrackerData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getRepTrackerData = async (selectedFilter) => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${envValues.REACT_APP_API_ENDPOINT}/statistics/rep-tracker/${userId}?filter=${selectedFilter}`,
        {
          headers: {
            Authorization: `${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response.data.data.repTracker.finalResult, 'check');
      setRepTrackerData(response.data.data.repTracker.finalResult);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getRepTrackerData(filter);
  }, [filter]);

  return (
    <div>
      <div className="inner_tab_head">
        <Tabs
          defaultActiveKey="weekly"
          id="justify-tab-example"
          className="mb-3"
          justify
          onSelect={(key) => key && setFilter(key)}
        >
          <Tab eventKey="weekly" title="Week">
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                }}
              >
                <SpinnerDotted style={{ color: '#207a4a' }} />
              </div>
            ) : (
              // <div className="resp_table">
              <Table className="table">
                <thead>
                  <tr>
                    <th>Muscle Group</th>
                    <th>Primary</th>
                    <th>Secondary</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {repTrackerData?.map((item) => (
                    <React.Fragment key={item.bodyName}>
                      <tr style={{ fontWeight: 'bold' }}>
                        <td colSpan={4}>{item.bodyName}</td>
                      </tr>

                      {item.muscleGroups.map((muscle) => (
                        <tr key={muscle.muscleGroupName}>
                          <td className="pl-4">
                            {muscle.isSmallerMuscle
                              ? `*${muscle.muscleGroupName}`
                              : muscle.muscleGroupName}
                          </td>
                          <td>{muscle.primary}</td>
                          <td>{muscle.secondary}</td>
                          <td>{muscle.total}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
              // </div>
            )}
          </Tab>
          <Tab eventKey="monthly" title="Month">
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                }}
              >
                <SpinnerDotted style={{ color: '#207a4a' }} />
              </div>
            ) : (
              <Table className="table">
                <thead>
                  <tr>
                    <th>Muscle Group</th>
                    <th>Primary</th>
                    <th>Secondary</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {repTrackerData?.map((item) => (
                    <React.Fragment key={item.bodyName}>
                      <tr style={{ fontWeight: 'bold' }}>
                        <td colSpan={4}>{item.bodyName}</td>
                      </tr>

                      {item.muscleGroups.map((muscle) => (
                        <tr key={muscle.muscleGroupName}>
                          <td className="pl-4">
                            {muscle.isSmallerMuscle
                              ? `*${muscle.muscleGroupName}`
                              : muscle.muscleGroupName}
                          </td>
                          <td>{muscle.primary}</td>
                          <td>{muscle.secondary}</td>
                          <td>{muscle.total}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            )}
          </Tab>
          <Tab eventKey="yearly" title="Year">
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                }}
              >
                <SpinnerDotted style={{ color: '#207a4a' }} />
              </div>
            ) : (
              <Table className="table">
                <thead>
                  <tr>
                    <th>Muscle Group</th>
                    <th>Primary</th>
                    <th>Secondary</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {repTrackerData?.map((item) => (
                    <React.Fragment key={item.bodyName}>
                      <tr style={{ fontWeight: 'bold' }}>
                        <td colSpan={4}>{item.bodyName}</td>
                      </tr>

                      {item.muscleGroups.map((muscle) => (
                        <tr key={muscle.muscleGroupName}>
                          <td className="pl-4">
                            {muscle.isSmallerMuscle
                              ? `*${muscle.muscleGroupName}`
                              : muscle.muscleGroupName}
                          </td>
                          <td>{muscle.primary}</td>
                          <td>{muscle.secondary}</td>
                          <td>{muscle.total}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            )}
          </Tab>
          <Tab eventKey="all" title="Lifetime">
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                }}
              >
                <SpinnerDotted style={{ color: '#207a4a' }} />
              </div>
            ) : (
              <Table className="table">
                <thead>
                  <tr>
                    <th>Muscle Group</th>
                    <th>Primary</th>
                    <th>Secondary</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {repTrackerData?.map((item) => (
                    <React.Fragment key={item.bodyName}>
                      <tr style={{ fontWeight: 'bold' }}>
                        <td colSpan={4}>{item.bodyName}</td>
                      </tr>

                      {item.muscleGroups.map((muscle) => (
                        <tr key={muscle.muscleGroupName}>
                          <td className="pl-4">
                            {muscle.isSmallerMuscle
                              ? `*${muscle.muscleGroupName}`
                              : muscle.muscleGroupName}
                          </td>
                          <td>{muscle.primary}</td>
                          <td>{muscle.secondary}</td>
                          <td>{muscle.total}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            )}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default repTrackerComponent;
